// state
import axios from "axios";
import commonrole from "../../../shared/common.service";

const defaultState = () => ({
  entity: {
    id: null,
    roleId: null,
    fullName: null,
    username: null,
    password: null
  },
  roleList: []
});

const state = defaultState();
// getters
const getters = {};

// actions
const actions = {
  loadUser({}, { pagination, search }) {
    return new Promise((resolve, reject) => {
      var param = {
        descending:
          pagination.sortDesc.length > 0 ? pagination.sortDesc[0] : false,
        page: pagination.page,
        rowsPerPage: pagination.itemsPerPage,
        sortBy: pagination.sortBy.length > 0 ? pagination.sortBy[0] : "name",
        search: search
      };
      axios
        .get("/bousers?" + commonrole.convertToQueryString(param))
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  setUser({ commit }, { id }) {
    return new Promise((resolve, reject) => {
      axios
        .get("/bousers/" + id)
        .then(response => {
          commit("SET_USER", response.data);
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  saveUser({ commit, state }) {
    return new Promise((resolve, reject) => {
      if (state.entity.id) {
        axios
          .patch("/bousers", state.entity)
          .then(response => {
            commit("RESET");
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      } else {
        axios
          .post("/bousers", state.entity)
          .then(response => {
            commit("RESET");
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      }
    });
  },
  deleteUser({ commit }, { id }) {
    return new Promise((resolve, reject) => {
      axios
        .delete("/bousers/" + id)
        .then(response => {
          commit("RESET");
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  approveUser({ commit }, { id }) {
    return new Promise((resolve, reject) => {
      axios
        .patch("/approvebousers",{userId:id})
        .then(response => {
          commit("RESET");
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  initUser({ commit }) {
    return new Promise((resolve, reject) => {
      axios
        .get("/list/role")
        .then(response => {
          commit("SET_ROLE_LIST", response.data);
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  }
};

// mutations
const mutations = {
  RESET(state) {
    const roleList = state.roleList;
    Object.assign(state, defaultState());
    state.roleList = roleList;
  },
  SET_USER_DATA(state, data) {
    if (Object.prototype.toString.call(state[data.key]) === "[object Array]") {
      state[data.key][data.index][data.property] = data.value;
    } else if (
      Object.prototype.toString.call(state[data.key]) === "[object Object]"
    ) {
      state[data.key][data.property] = data.value;
    } else state.entity[data.key] = data.value;
  },
  SET_USER(state, data) {
    state.entity.id = data.id;
    state.entity.roleId = data.roleId;
    state.entity.fullName = data.fullName;
    state.entity.password = data.password;
    state.entity.username = data.username;
    state.entity.statusid = data.statusid;
  },
  SET_ROLE_LIST(state, data) {
    state.roleList = data;
  },
  SET_STATUS_LIST(state, data) {
    state.statusList = data;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
